import { cargas } from './cargas'

export const all = {
    pvCargas: cargas
}